import { useEffect } from "react";

interface ManifestOptions {
  name: string;
  shortName: string;
  startUrl: string;
}

export function useDynamicManifest({ name, shortName, startUrl }: ManifestOptions) {
  useEffect(() => {
    const manifest = {
      name,
      short_name: shortName,
      start_url: startUrl,
      scope: "/",
      display: "standalone",
      background_color: "#ffffff",
      theme_color: "#1a73e8",
      icons: [
        { src: "/assets/icon-192.png", sizes: "192x192", type: "image/png" },
        { src: "/assets/icon-512.png", sizes: "512x512", type: "image/png" }
      ]
    };

    const blob = new Blob([JSON.stringify(manifest)], { type: "application/json" });
    const manifestURL = URL.createObjectURL(blob);

    const link = document.querySelector('link[rel="manifest"]') as HTMLLinkElement;
    const originalHref = link?.getAttribute("href") ?? "/manifest.json";
    link?.setAttribute("href", manifestURL);

    return () => {
      link?.setAttribute("href", originalHref);
      URL.revokeObjectURL(manifestURL);
    };
  }, [name, shortName, startUrl]);
}
